<template>
  <div>
    <div class="layout-column flex">
      <div class="flex-gt-sm-100 layout-row">
        <div class="flex-gt-sm-40 flex-100 px-2">
          <validation-provider tag="div"
                               :name="path + '.ecog'"
                               :ref="path + '.ecog'"
                               rules=""
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              label="ECOG *"
              v-model="model.ecog"
              :items="ecogArray"
              @change="setValuesNull('ecog')"
              outlined
              :disabled="isDisabled"
              :dense="denseFields"
              :error-messages="errors[0]"
              :hide-details="!errors || errors.length <= 0"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <div class="mx-4" :class="denseFields ? 'pt-2' : 'pt-3'"><label style="font-size: 15px;" :style="{color: compColor.primeColor}">{{ $t('OR') }}</label></div>

        <div class="flex-gt-sm-30 flex-100 px-2">
          <validation-provider tag="div"
                               :name="path + '.karnofsky'"
                               :ref="path + '.karnofsky'"
                               rules=""
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              label="Karnofsky Index (%) *"
              v-model="model.karnofsky"
              :items="karnofskyArray"
              @change="setValuesNull('karnofsky')"
              outlined
              :disabled="isDisabled"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <div class="mx-4" :class="denseFields ? 'pt-2' : 'pt-3'"><label style="font-size: 15px;" :style="{color: compColor.primeColor}">{{ $t('OR') }}</label></div>

        <div class="layout-row md12 sm12 xs12 ml-2 mt-n1" :class="denseFields ? 'pt-0' : 'pt-1'">
          <validation-provider tag="div"
                               :name="path + '.allgemeiner_leistungszustand_nd'"
                               :ref="path + '.allgemeiner_leistungszustand_nd'"
                               rules=""
                               v-slot="{ errors }">
            <v-checkbox :dark="compColor.isInDarkMode"
                        :color="compColor.primeColor"
                        class="my-0 py-0"
                        hide-details
                        :disabled="isDisabled"
                        @change="setValuesNull('nd')"
                        :error-messages="errors[0]"
                        v-model="model.allgemeiner_leistungszustand_nd">
            </v-checkbox>
          </validation-provider>

          <label class="pr-2 pt-3" style="font-size: 16px;"
                 :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.UNKNOWN') }}</label>
        </div>
      </div>

      <!-- hidden input field to show error, if object of performance state is empty -->

      <div class="flex-gt-sm-100 px-2">
        <validation-provider
          :name="path"
          :ref="path"
          :rules="{at_least_one_performance_state_is_selected: [model.ecog, model.karnofsky, model.allgemeiner_leistungszustand_nd]}"
          v-slot="{ errors }">
          <lx-alert-box v-show="errors[0]" color="red" class="mb-4">
            {{ $t('ERROR_EMPTY_PERFORMANCE_STATE') }}
          </lx-alert-box>

          <v-text-field
            v-model="model"
            :name="path"
            v-show="false"
            outlined
          ></v-text-field>
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: 'Leistungszustand',
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    }
  },
  data () {
    return {
      model: {},
      ecogArray: null,
      karnofskyArray: null
    }
  },
  created () {
    this.ecogArray = this.formsMetaData.ecogArray
    this.karnofskyArray = this.formsMetaData.karnofskyArray
  },
  methods: {
    // set values of ecog and karnofsky to null if checkbox is set
    setValuesNull (value) {
      if (value === 'nd') {
        this.$set(this.model, 'ecog', null)
        this.$set(this.model, 'karnofsky', null)
      } else if (value === 'ecog') {
        this.$set(this.model, 'allgemeiner_leistungszustand_nd', false)
        this.$set(this.model, 'karnofsky', null)
      } else {
        this.$set(this.model, 'allgemeiner_leistungszustand_nd', false)
        this.$set(this.model, 'ecog', null)
      }

      // validate module to trigger error-bag of parent-validator and show error message
      if (this.$refs && this.$refs[this.path]) {
        this.$nextTick(() => {
          this.$refs[this.path].validate()
        })
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
